import { render, staticRenderFns } from "./third-party.vue?vue&type=template&id=c87050a0&scoped=true&"
import script from "./third-party.vue?vue&type=script&lang=js&"
export * from "./third-party.vue?vue&type=script&lang=js&"
import style0 from "./third-party.vue?vue&type=style&index=0&id=c87050a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87050a0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDatePicker,VMenu,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c87050a0')) {
      api.createRecord('c87050a0', component.options)
    } else {
      api.reload('c87050a0', component.options)
    }
    module.hot.accept("./third-party.vue?vue&type=template&id=c87050a0&scoped=true&", function () {
      api.rerender('c87050a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/management/collection/third-party.vue"
export default component.exports